let kbase = {
  showItems: false,
  searchFilters: {
    search_query: null,
    classifiers: [],
    types: {},
  }
};

const getters = {};
const mutations = {
  RESET_SEARCH(state) {
    state.showItems = false;
    state.searchFilters.search_query = "";
    state.searchFilters.classifiers = [];
    state.searchFilters.types = {};
  },
  SET_SEARCH_FILTERS(state, data) {
    state.showItems = true;
    if (data.hasOwnProperty('search_query')) state.searchFilters.search_query = data.search_query;
    if (data.hasOwnProperty('classifiers')) state.searchFilters.classifiers = data.classifiers;
    if (data.hasOwnProperty('types')) state.searchFilters.types = data.types;
  }
};

const actions = {
  setSearchFilters({ commit }, data) {
    commit("SET_SEARCH_FILTERS", data);
  },
  hideItems({ commit }) {
    commit("HIDE_ITEMS");
  },
  resetSearch({ commit }) {
    commit("RESET_SEARCH");
  }
};

export default {
  namespaced: true,
  state: kbase,
  getters,
  mutations,
  actions
};
